import store from '@/store';
import { CONTRACT, MEMBERSHIP } from '@/store/types';
import { Sentry } from '@/sentry';

async function setAuthenticated(ctx, user) {
  ctx.user = user;
  ctx.isLoggedIn = true;

  const { publisher, email } = user;

  Sentry.setUser({ email });

  if (publisher) {
    store.dispatch(CONTRACT, publisher.contractState);
    store.dispatch(MEMBERSHIP, publisher.membershipInfo);
  }
}

export default setAuthenticated;
